
































































































import { Component, Vue, Prop } from "vue-property-decorator";
import { ContactModel, OrganisationModel, PrivatePersonModel } from "../models";
import { RelationType } from "../../../shared/store/auth/types";

@Component
export default class RelationData extends Vue {
  @Prop({ required: true })
  value!: OrganisationModel | PrivatePersonModel;
  @Prop({ required: true })
  type!: RelationType;
  @Prop({ default: false })
  link!: boolean;

  get icon(): string {
    return this.isPrivatePerson ? "user" : "users";
  }

  get isPrivatePerson(): boolean {
    return this.type === RelationType.private;
  }

  get isOrganisation(): boolean {
    return this.type === RelationType.contact;
  }

  get organisation(): OrganisationModel {
    if (!this.isOrganisation) return new OrganisationModel();
    return this.value as OrganisationModel;
  }

  get privatePerson(): PrivatePersonModel {
    if (!this.isPrivatePerson) return new PrivatePersonModel();
    return this.value as PrivatePersonModel;
  }

  get mainContact(): ContactModel | undefined {
    return this.organisation.contacts.find(
      (c) => c.id === this.organisation.main_contact
    );
  }

  get name(): string {
    if (this.isPrivatePerson) {
      return this.privatePerson.first_name + " " + this.privatePerson.last_name;
    }
    if (this.isOrganisation) {
      return this.organisation.name;
    }
    return "";
  }
}
